import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactImageFallback from "react-image-fallback";
import { slice } from 'lodash';
import {
    toggleClubBoxWeb,
    resetTeamFilter,
    applyClubBoth,
} from './../../../actions/FilterActions';
import config from '../../../config';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import ClubsFilterListElement from './ClubsFilterListElement'

class ClubsFilterWeb extends Component {
    onTeamFilterOpen = () => {
        this.props.toggleClubBoxWeb();
        if (!this.props.isClubFilterOpenForWeb) {
            common.customTracking('Select Clubs filter',common.getPageName());
        }
    };
    resetTeamFilter = (e) => {
        e.stopPropagation();
        this.props.resetTeamFilter()
    };
    onClubFilterApply = (club, e) => {
        e.stopPropagation();
        this.props.applyClubBoth(club);
        common.customTracking('Select Club filter - ' + club.WebName,common.getPageName());
    };

    mapTeamId = (teamId) => {

        let teamObj = {};
        this.props.teams.map((el) => {
            if (el.TID == teamId) {
                teamObj = el;
            }
        })
        return teamObj;
    }

    render() {
        const teamIDs = this.props.teamIds;
        const clubDisplayName = teamIDs.length ? '' : this.props.trans.all;
        const clubsToDisplay = slice(teamIDs, 0, 3);
        const diff = (teamIDs.length - 3);
        const countLeft = diff > 0 ? '+' + diff : '';
        const teamFilterClass = common.makeClasses({
            'si-selectBoxes': true,
            'si-custom': true,
            'si-active': this.props.isClubFilterOpenForWeb
        });
        return <div className="si-club-filter si-more-filters">
            <div className="si-dropdown-wrap">
                {/* <label>{this.props.trans['filterByTeam']}</label> */ }
                <div className={ teamFilterClass }>
                    <div className="si-dropdown-btn si-flexBox"
                        onClick={ () => this.onTeamFilterOpen() }>
                        { teamIDs.length <= 0 ? <div className="si-tp-wrap si-flexBox">
                            <span className="si-tp">{ this.props.trans.clubsDrpWeb ? this.props.trans.clubsDrpWeb : "Clubs" }</span>
                        </div> : "" }
                        {
                            teamIDs.length ?
                                <div className="si-selected-clubs si-flexBox">
                                    <div className="si-selected-wrap si-flexBox">{
                                        clubsToDisplay.map(teamID => {
                                            const teamImg = config.UEFAImgBase + "teams/logos/140x140/" + teamID + ".png";
                                            return <div className="si-club-img-small"
                                                key={ teamID } onClick={ (e) => { this.onClubFilterApply(this.mapTeamId(teamID), e) } }>
                                                <ReactImageFallback
                                                    src={ teamImg }
                                                    initialImage={ config.playerImgBase + "default_jersey@2x.png" }
                                                    fallbackImage={ config.playerImgBase + "default_jersey@2x.png" }
                                                    alt="" />
                                            </div>
                                        })
                                    }
                                        <span className="si-selected-clubs-count">{ countLeft }</span>
                                    </div>
                                    <span className="si-close">
                                        <i className="icon-ucl-close"
                                            onClick={ (e) => this.resetTeamFilter(e) } />
                                    </span>
                                </div> :
                                // <div className={'si-tp-wrap si-flexBox'}><span
                                //     className={'si-tp'}>{clubDisplayName}</span>
                                //     <i className="icon-ucl-arrow_down" /></div>
                                // <div className="si-tp-wrap si-flexBox">
                                //     <span className="si-tp">{this.props.trans.clubsDrpWeb ? this.props.trans.clubsDrpWeb : "Clubs"}</span>
                                // </div>
                                ""
                        }
                        {/* <span className="si-close" onClick={(e) => this.resetTeamFilter(e)}>
                            <i className="icon-ucl-close"></i>
                        </span> */}
                        <i className="icon-ucl-position"></i>
                    </div>
                    { this.props.isClubFilterOpenForWeb ? <OutsideNotifier handler={ () => this.onTeamFilterOpen() }>
                        <ul className="si-dropdown-options">
                            <Scrollbars autoHide>
                                { this.props.teams.map((el) => {
                                    const teamID = el['TID'];
                                    const propsToPass = { teamIDs, el, onClubFilterApply: this.onClubFilterApply.bind(this) };
                                    return <ClubsFilterListElement key={ teamID } { ...propsToPass } />
                                }) }
                            </Scrollbars>
                        </ul>
                    </OutsideNotifier> : null }
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teams: state.formationData.teams,
        teamIds: state.formationData.playerFilters.teamIds,
        isClubFilterOpenForWeb: state.formationData.isClubFilterOpenForWeb,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleClubBoxWeb: () => dispatch(toggleClubBoxWeb()),
        resetTeamFilter: () => dispatch(resetTeamFilter()),
        applyClubBoth: (club) => dispatch(applyClubBoth(club)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ClubsFilterWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ClubsFilterWeb.js